// extracted by css-extract-rspack-plugin
export default {"container":"container--s_pFR4YbTqcbQaUP"};